import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Template from './template';
import { ServiceDocReject } from 'components';
import { useApiRequest } from 'hooks';
import { apiGetDocRejectInfo } from 'api/ZimssaAPI';
import { getDocRejectComment } from 'commons/ZimssaHelper';
import { DOC_REVIEW } from 'router/PageUrl';

function ServiceDocRejectView(): React.ReactElement {
    const history = useHistory();
    const { serviceType, serviceIdx } = useParams<{ serviceType: string, serviceIdx: string }>();

    const [fetchResult, fetchRejectInfo] = useApiRequest<any>(apiGetDocRejectInfo);
    const [rjectInfo, setRjectInfo] = useState<{
        documentDenialComment: string;
        rejectList: Array<string>;
    }>({ documentDenialComment: '', rejectList: [] });

    useEffect(() => {
        if (serviceIdx && serviceType) {
            fetchRejectInfo({
                type: 'REQUEST',
                body: [Number(serviceIdx), serviceType],
            });
        }
    }, [fetchRejectInfo, serviceIdx, serviceType]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success') {
            const respnseData: { [key: string]: any } = data;
            setRjectInfo({
                documentDenialComment: respnseData['documentDenialComment'],
                rejectList: Object.keys(respnseData)
                    .filter((item) => respnseData[item] === false)
                    .map((item) => getDocRejectComment(item)),
            });
        }
    }, [fetchResult]);

    const onClickCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (serviceType) {
                history.push(`${DOC_REVIEW.url}/${serviceType}/${serviceIdx}`);
            }
        },
        [history, serviceIdx, serviceType]
    );

    const docRjectProps = {
        documentDenialComment: rjectInfo.documentDenialComment,
        rjectInfoList: rjectInfo.rejectList,
        onClick: onClickCallback,
    };
    return (
        <Template>
            <ServiceDocReject {...docRjectProps} />
        </Template>
    );
}

export default ServiceDocRejectView;
